export default __webpack_public_path__ + "static/media/icon_plus.0d8d7172.svg";